import { defineBlock, EditableText, InnerBlocks } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Expandable List",
  tags: ["#page", "#inline"],
}

export default defineBlock("content/expandable-list", (props) => {
  return (
    <div className="expandable-list content-sized block-spacing flex items-center justify-center">
      <div className="w-full flex flex-col gap-6 md:w-narrowContentW">
        <EditableText
          tag="h2"
          store="expandableListTitle"
          className="type-title-s w-full text-center text-blue"
          placeholder="Expandable List Title"
        />
        <InnerBlocks
          allowedBlocks={["content/expandable-list-item"]}
          template={[
            ["content/expandable-list-item", {}],
            ["content/expandable-list-item", {}],
            ["content/expandable-list-item", {}],
          ]}
          className="w-full flex flex-col border-t border-blue"
        />
      </div>
    </div>
  )
})
